const platforms = [
  {
    name: 'ISNetworld®',
    href: 'http://isnetworld.com',
    logo: 'https://www.energycontractorservices.com/wp-content/uploads/2013/04/Screen-shot-2013-05-30-at-10.38.08-AM.png',
    tag: 'Primary Platform',
    logoBg: 'bg-white',
    description:
      'The industry standard for contractor prequalification used by hundreds of major energy operators. We manage your entire ISNetworld account — setup, maintenance, documentation, RAVS Plus, and score optimization.',
  },
  {
    name: 'Veriforce',
    href: 'https://veriforce.com/',
    logo: 'https://www.energycontractorservices.com/wp-content/uploads/2024/06/veri-2.png',
    tag: 'Compliance Platform',
    logoBg: 'bg-white',
    description:
      'A comprehensive compliance and workforce management platform widely adopted across the energy sector. ECS handles your full Veriforce qualification, documentation, and ongoing account maintenance.',
  },
  {
    name: 'Avetta',
    href: 'https://www.avetta.com',
    logo: 'https://www.energycontractorservices.com/wp-content/uploads/2012/06/avetta-logo-white-768x265-300x104.png',
    tag: 'Global Platform',
    logoBg: 'bg-[#0A2540]',
    description:
      'A global supply chain risk management platform connecting contractors to major clients in energy, utilities, and industrial sectors. ECS manages Avetta qualification from onboarding through ongoing compliance.',
  },
];

export default function PlatformPartners() {
  return (
    <section className="bg-[#080808] w-full">
      <div className="w-full h-px bg-gradient-to-r from-transparent via-[#C9A030]/35 to-transparent" />

      <div className="w-full px-6 lg:px-14 py-20 lg:py-28">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#C9A030] text-[10px] tracking-[0.48em] uppercase font-semibold mb-5">
            Certified Platform Expertise
          </p>
          <h2 className="font-serif text-white text-3xl lg:text-5xl font-light mb-6 leading-tight">
            The Platforms That Control Your Contracts
          </h2>
          <p className="text-[#787878] text-base lg:text-lg font-light max-w-2xl mx-auto leading-relaxed">
            ISNetworld®, Veriforce, and Avetta are the gatekeepers to the largest energy contracts in
            North America. ECS are deep specialists in all three — so your team never has to be.
          </p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <div className="w-10 h-px bg-[#C9A030]/40" />
            <div className="w-2 h-2 rounded-full bg-[#C9A030]" />
            <div className="w-10 h-px bg-[#C9A030]/40" />
          </div>
        </div>

        {/* Platform cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {platforms.map((platform, idx) => (
            <a
              key={platform.name}
              href={platform.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative flex flex-col cursor-pointer border border-[#222] hover:border-[#C9A030]/40 transition-all duration-300 overflow-hidden"
            >
              {/* Gold sweep on hover */}
              <div className="absolute top-0 left-0 w-0 h-[3px] bg-[#C9A030] group-hover:w-full transition-all duration-500" />

              {/* Logo showcase — large prominent display */}
              <div className={`${platform.logoBg} w-full flex items-center justify-center`} style={{ height: '280px', padding: '40px' }}>
                <img
                  src={platform.logo}
                  alt={platform.name}
                  style={{ maxHeight: '160px', maxWidth: '340px', width: 'auto', height: 'auto', objectFit: 'contain', display: 'block' }}
                />
              </div>

              {/* Content */}
              <div className="flex flex-col flex-1 p-8 bg-[#0E0E0E]">
                <span className="inline-block text-[#C9A030] text-[8px] tracking-[0.42em] uppercase font-bold mb-4 border border-[#C9A030]/25 px-3 py-1.5 w-fit">
                  {platform.tag}
                </span>
                <h3 className="font-serif text-[#F0EBE0] text-2xl font-light mb-3 tracking-tight">
                  {platform.name}
                </h3>
                <p className="text-[#686868] text-sm font-light leading-relaxed flex-1 group-hover:text-[#8A8A8A] transition-colors duration-300">
                  {platform.description}
                </p>
                <div className="flex items-center justify-between mt-8 pt-5 border-t border-[#1E1E1E]">
                  <span className="text-[#C9A030]/30 font-serif text-4xl font-light leading-none">
                    0{idx + 1}
                  </span>
                  <div className="flex items-center gap-1.5 text-[#C9A030]/40 group-hover:text-[#C9A030] transition-colors duration-300">
                    <span className="text-[9px] tracking-[0.22em] uppercase font-semibold">
                      Visit Platform
                    </span>
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-up-line text-xs" />
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

        <p className="text-center text-[#2A2A2A] text-[10px] font-light tracking-[0.14em] mt-10 leading-relaxed">
          ECS is not endorsed, sponsored, or affiliated with ISNetworld®, Veriforce, or Avetta.
          All platform names and logos are trademarks of their respective owners.
        </p>
      </div>

      <div className="w-full h-px bg-gradient-to-r from-transparent via-[#C9A030]/12 to-transparent" />
    </section>
  );
}
